import { render, staticRenderFns } from "./footerLanding.vue?vue&type=template&id=a0ab2d82&"
import script from "./footerLanding.vue?vue&type=script&lang=js&"
export * from "./footerLanding.vue?vue&type=script&lang=js&"
import style0 from "./footerLanding.vue?vue&type=style&index=0&id=a0ab2d82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports